export const getShiftedCircularIdx = (current: number, length: number, shift: number): number =>
  (((current + shift) % length) + length) % length

/**
 * When given 2 numeric ranges, will return true if and only if:
 * - Every number in the subset is also in the superset
 * - The subset is not equal to the superset
 *
 * 'proper subset' is a term that means something in mathematics,
 * see https://mathinsight.org/definition/proper_subset
 *
 * @param subset - A numeric range for the subset candidate
 * @param superset - A numeric range for the superset candidate
 *
 * @returns True if the subset is a proper subset of the superset, false otherwise
 */
export const isProperSubset = (subset: [number, number], superset: [number, number]): boolean =>
  (superset[0] <= subset[0] && superset[1] > subset[1]) ||
  (superset[0] < subset[0] && superset[1] >= subset[1])

/**
 * Get the duplicates in an array
 * @param array - The array to get duplicates from
 * @returns The duplicates in the array
 */
export const getDuplicates = <T extends string | number | boolean>(array: T[]): T[] => {
  const uniqueArray = new Set(array)
  if (uniqueArray.size === array.length) {
    return []
  }

  const duplicates = [...array]
  uniqueArray.forEach((x) => {
    const index = duplicates.indexOf(x)
    if (index !== -1) {
      duplicates.splice(index, 1)
    }
  })
  return duplicates
}
